import { render, staticRenderFns } from "./workTaskDetails.vue?vue&type=template&id=6a227062&scoped=true&"
import script from "./workTaskDetails.vue?vue&type=script&lang=js&"
export * from "./workTaskDetails.vue?vue&type=script&lang=js&"
import style0 from "./workTaskDetails.vue?vue&type=style&index=0&id=6a227062&scoped=true&lang=css&"
import style1 from "./workTaskDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a227062",
  null
  
)

export default component.exports